exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".sw-v2-ttl-editor-element-lifespan .ant-input-group-wrapper{max-width:180px}.sw-v2-ttl-editor-element-lifespan .ant-input-group-wrapper #ttlMetric{width:100px}", ""]);
